import * as React from "react";
import { useUserInfo } from "./hooks/useUserInfo";
import { Navigate } from "react-router-dom";
import {Circles} from "react-preloaders2";

interface Props {
    children: React.ReactNode;
}

export const AdminGuard: React.FC<Props> = ({ children }) => {
    const { userInfo } = useUserInfo();

    if (!userInfo) {
        return <Circles customLoading={true}/>;
    }

    if (userInfo.role !== "Admin") {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};
